export default "__VITE_ASSET__CrpJs2BW__"